module.exports = __webpack_public_path__ + "img/onderdelen_header.0857be43.webp";